const so = (s: string) => s.replace(/\D/g, '');

export function normalizarTelefone(entrada: string): string | null {
  let d = so(entrada);
  if (d.startsWith('00')) d = d.slice(2);
  if (d.length === 10 || d.length === 11) d = '55' + d;
  if (!d.startsWith('55') || (d.length !== 12 && d.length !== 13)) return null;
  if (d.length === 12 && /^[6-9]/.test(d.slice(4))) d = d.slice(0, 4) + '9' + d.slice(4);
  const ddd = d.slice(2, 4);
  const num = d.slice(4);
  if (ddd[0] === '0' || ddd[1] === '0') return null;
  if (num.length === 9 ? num[0] !== '9' : !/^[2-5]/.test(num)) return null;
  return '+' + d;
}

export function variacoesTelefone(e164: string): string[] {
  const d = so(e164).replace(/^55/, '');
  const ddd = d.slice(0, 2);
  const num = d.slice(2);
  const sem9 = num.length === 9 && num.startsWith('9') ? num.slice(1) : null;
  const v = new Set<string>([
    d,
    ddd + num,
    `(${ddd}) ${num.slice(0, -4)}-${num.slice(-4)}`,
    '55' + d,
  ]);
  if (sem9) {
    v.add(ddd + sem9);
    v.add(`(${ddd}) ${sem9.slice(0, 4)}-${sem9.slice(4)}`);
  }
  return [...v];
}

export function formatarTelefone(e164: string): string {
  const d = so(e164).replace(/^55/, '');
  if (d.length < 10) return e164;
  const ddd = d.slice(0, 2);
  const num = d.slice(2);
  return `(${ddd}) ${num.slice(0, -4)}-${num.slice(-4)}`;
}
